export default (value, words, withCount = false) => {
  if (!value) return words[0];
  const doubleNum = Math.abs(value) % 100;
  const num = doubleNum % 10;
  if (doubleNum > 10 && doubleNum < 20)
    return (withCount ? value + ' ' : '') + words[3];
  if (num > 1 && num < 5) return (withCount ? value + ' ' : '') + words[2];
  if (num === 1) return (withCount ? value + ' ' : '') + words[1];
  return (withCount ? value + ' ' : '') + words[3];
};
